<template>
<div class="container">
  <h2 class="title">Quem é você?</h2>
  <div v-if="error_message" class="error-panel">{{ error_message }}</div>
  <div class="ui five column grid" style="width: 80%; margin: 0 auto;">
    <paginate
      name="customers"
      :list="sortedCustomers"
      :per="8"
      style="border: 1px solid; display: contents;"
    >
      <div v-for="customer in paginated('customers')" :key="customer.id"
        :class="['column', { inactive: is_loading }]" @click="schedulings(customer.id)">
        <div class="customer-photo">
          <img v-show="customer.image" :src="$baseUrl + '/storage/' + customer.image" alt="">
          <i v-show="customer.image == null" class="user circle icon"></i>
        </div>
        <div class="customer-name">
          <span>{{ customer.name }}</span>
        </div>
      </div>
    </paginate>
  </div>
  <div class="footer-btn">
    <div id="back-btn" class="btn btn-cancel" @click.prevent="$emit('backClicked', 'StartPage');">
      <i class="ui sign-out icon"></i>
      <span>Cancelar</span>
    </div>

    <paginate-links
      for="customers"
      :simple="{
        prev: 'Voltar',
        next: 'Mais...'
      }"
    ></paginate-links>
  </div>
</div>
</template>
<script>
import orderBy from 'lodash/orderBy';
export default {
  props: {
      customers: Array,
  },
  data() {
    return {
      paginate: ['customers'],
      is_loading: false,
      error_message: ''
    }
  },
  computed: {
    sortedCustomers() {
      return orderBy(this.customers, 'name');
    }
  },
  methods: {
    async schedulings(id) {
      if (this.is_loading) return;
      this.is_loading = true;
      this.error_message = '';
      try {
        const { data } = await axios.get('api/kiosk/customer/customerschedulingid/' + id);
        this.$emit('setRequisitions', data.data.schedulings);
        this.$emit('buttonClicked', 'FinishCheckin')
      } catch (err) {
        this.error_message = 'Não foi possível consultar os agendamentos. Tente novamente.';
      } finally {
        this.is_loading = false;
      }
    },
    backClicked(section) {
      this.$emit('backClicked', section);
    },
  }
}
</script>
<style scoped>
@media only screen and (min-width: 320px) {
  .ui.five.column.grid {
    width: 100%;
    margin: 0px;
  }
  .ui.five.column.grid .column {
    display: flex;
    width: 100%;
    height: 87px;
    margin-bottom: 2px;
    padding: 0px;
  }
  .column .customer-photo {
    padding-left: 4px;
    height: inherit;
  }
  .ui.grid .column img {
    float: left;
    width: 70px;
    height: 70px;
  }
  .customer-photo i {
    float: left;
    width: fit-content;
    font-size: 70px;
    line-height: 70px;
  }
  .customer-name {
    padding-top: 10px;
    padding-left: 6px;
  }
}

@media only screen and (min-width: 500px) {
  .ui.five.column.grid {
    display: flex;
    height: fit-content;
    padding: 20px;
  }
  .ui.five.column.grid .column {
    width: 500px;
    height: 160px;
    padding: 10px;
  }
  .customer-photo i {
    width: 100%;
    font-size: 140px;
    line-height: 140px;
  }
  .customer-name {
    //padding-top: 30px;
    padding-left: 6px;
    align-self: center;
  }
  .customer-name span {
    font-size: 22px;
  }
  .ui.grid .column img {
    width: 140px;
    height: 140px;
  }
}

h2 {
  font-size: 42px;
  font-weight: bold;
  font-family: 'Source Sans Light';
  color: #fff;
}
/* .ui.grid .column {
  height: fit-content;
  padding: 20px;
} */
.ui.five.column.grid .column {
  //height: 206px;
  margin: 0 auto;
  margin-bottom: 4px;
  padding-top: 10px;
  background: #56ccf2;
  border-radius: 6px;
  box-shadow: 0px 10px 8px rgba(0, 0, 0, 0.22), 0 1px 2px rgba(0, 0, 0, 0.23);
  cursor: pointer;
}
.ui.five.column.grid .column.inactive {
  pointer-events: none;
  opacity: .55;
}
.customer-photo {
  /* height: 206px;
  margin: 0 auto;
  padding-top: 10px;
  background: #56ccf2;
  border-radius: 20px;
  box-shadow: 0px 10px 8px rgba(0, 0, 0, 0.22), 0 1px 2px rgba(0, 0, 0, 0.23);
  cursor: pointer; */
}
.customer-photo i {
  color: #fff;
}
.ui.grid .column img {
  //width: 180px;
  //height: 180px;
  border-radius: 500px;
  border: 5px solid #fff;
}
.customer-name {
  color: #fff;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/CheckinCustomers.vue